import { createModel } from "nyax";
import { AppTemplate } from "src/models/appTemplate";
import { AppTemplateEntityModel } from "src/store/models/entity/appTemplate/entity";
import { createUIListV2Model } from "src/store/models/ui/_shared";

export const AppTemplateListModel = createModel(
  class extends createUIListV2Model<AppTemplate>({
    setItems: (getContainer, items) =>
      getContainer(AppTemplateEntityModel).actions.setItems.dispatch(items),
    getItems: (getContainer) =>
      getContainer(AppTemplateEntityModel).getters.items,
    getItem: (getContainer, id) =>
      getContainer(AppTemplateEntityModel).state.byId[id],
    getItemId: (item) => item.id,
  }) {
    public effects() {
      return {
        ...super.effects(),
        initial: async () => {
          this._initial({
            initialAction: () =>
              this.dependencies.serviceClient.appTemplate.getList(),
          });
        },
      };
    }
  }
);
